"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaneHeader = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var Box_1 = require("../Box");
var mixins_1 = require("../mixins");
var PaneOption_1 = require("./PaneOption");
exports.PaneHeader = (0, styled_components_1.default)(Box_1.Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), mixins_1.overflowEllipsisMixin);
exports.PaneHeader.defaultProps = __assign(__assign({}, PaneOption_1.PANE_OPTION), { color: "secondary" });
var templateObject_1;
//# sourceMappingURL=PaneHeader.js.map